import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Services from './components/Services';
import Cases from './components/Cases';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Sections */}
      <section id="home">
        <Hero />
      </section>
      
      <section id="about">
        <About />
      </section>
      
      <section id="products">
        <Products />
      </section>
      
      <section id="services">
        <Services />
      </section>
      
      <section id="cases">
        <Cases />
      </section>
      
      <section id="contact">
        <Contact />
      </section>

      <Footer />
    </div>
  );
}
